import { useLocation } from "react-router-dom";
import OrdersTable from "./OrdersTable";

export const NotificationPage = () => {
    const location = useLocation();
    return <OrdersTable key={location.key} />
 }